export default "__VITE_ASSET__Da4B2T9z__"